import * as angular from "angular";
import {IController} from "angular";

export class SupplyAccountSideNavTabsComponent implements IController {

  constructor() {
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountSideNavTabs', {
    template: require('./supply-account-side-nav-tabs.html').default,
    controller: SupplyAccountSideNavTabsComponent
  });
